import React from 'react';
import { Link } from 'react-router-dom';

function EditorialIntro({ heading, intro, eyebrow = 'Photographic letter art' }) {
  return (
    <section className="editorial-intro" aria-labelledby="page-heading">
      <div className="editorial-shell">
        <p className="editorial-eyebrow">{eyebrow}</p>
        <h1 id="page-heading">{heading}</h1>
        <p className="editorial-lead">{intro}</p>
      </div>
    </section>
  );
}

function EditorialSections({ sections, ariaLabel = 'More about Craig Photo Letters' }) {
  return (
    <section className="editorial-sections" aria-label={ariaLabel}>
      <div className="editorial-shell editorial-grid">
        {sections.map((section, index) => (
          <article className="editorial-card" key={section.heading}>
            <span className="editorial-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
            <div>
              <h2>{section.heading}</h2>
              {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {section.links?.length > 0 && (
                <nav className="editorial-links" aria-label={`${section.heading} links`}>
                  {section.links.map((link) => link.to.startsWith('#') ? (
                    <a key={link.to} href={link.to}>{link.label}</a>
                  ) : (
                    <Link key={link.to} to={link.to}>{link.label}</Link>
                  ))}
                </nav>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export { EditorialIntro, EditorialSections };
